<template>
  <div class="loader">
    <div class="inner-loader">
      Loading
    </div>
  </div>
</template>

<script>
export default {
  name: 'loader',
};
</script>

<style lang="scss">
.loader {
  opacity: .2;
  background-image: radial-gradient($color_black, rgba(0, 0, 0, 0));;
  color: $color_white;
  font-weight: 800;
  font-size: $font-size-l;
  height: 100%;
  display: flex;
  flex-grow: 1;
  justify-content: center;
}

.inner-loader {
  padding: 40px 20px;
}
</style>
